import { createRouter, createWebHistory } from 'vue-router';
import { useAuth0 } from '@auth0/auth0-vue';

import Dashboard from '../views/Dashboard.vue';
import UserAccount from '../views/Profile/UserAccount.vue';
import Support from '../views/Support.vue';
import Transactions from '../views/Transactions.vue';
import EditTransaction from '../views/EditTransaction.vue';
import Categories from '../views/Categories.vue';
import AddCategory from '../views/AddCategory.vue';
import EditCategory from '../views/EditCategory.vue';
import AddTransaction from '../views/AddTransaction.vue';
import Budget from '../views/Budget.vue';
import NetWorth from '../views/NetWorth.vue';
import CategoryTransactions from '../views/CategoryTransactions.vue';
import AddAccount from '../views/AddAccount.vue';
import EditAccount from '../views/EditAccount.vue';
import SignIn from '../views/SignIn.vue';
import UserProfile from '../views/Profile/UserProfile.vue';
import ConnectedAccounts from '../views/Profile/ConnectedAccounts.vue';
import EditCategoryBudget from '../views/EditCategoryBudget.vue';
import AnnualBudgetDetails from '../views/AnnualBudgetDetails.vue';
import ConnnectAccounts from '..//views/CreateAccount/ConnectAccounts.vue';
import UserCategoryData from '../views/CreateAccount/UserCategoryData.vue';
import UserData from '../views/CreateAccount/UserData.vue';
import Settings from '../views/Profile/UserSettings.vue';
import StripePayments from '../views/CreateAccount/StripePayment.vue';
import TypeOfAccountCreation from '../views/CreateAccount/TypeOfAccountCreation.vue';
import JuniorUserData from '../views/CreateAccount/JuniorUserData.vue';
import JuniorCategoryData from '../views/CreateAccount/JuniorCategoryData.vue';
import ConnectJuniorAccounts from '../views/CreateAccount/ConnectJuniorAccounts.vue';
import Legal from '../views/Profile/Legal.vue';
import DataDeletion from '../views/Profile/LegalDocuments.vue/DataDeletion.vue';
import EndUserLicense from '../views/Profile/LegalDocuments.vue/EndUserLicense.vue';
import PlaidEndUser from '../views/Profile/LegalDocuments.vue/PlaidEndUser.vue';
import PrivacyPolicy from '../views/Profile/LegalDocuments.vue/PrivacyPolicy.vue';
import TermsOfUse from '../views/Profile/LegalDocuments.vue/TermsOfUse.vue';
import Calculators from '../views/Profile/Tools/Calculators.vue';
import Affordability from '../components/Calculators/Affordability.vue';
import CompoundInterest from '../components/Calculators/CompoundInterest.vue';
import DebtPayoff from '../components/Calculators/DebtPayoff.vue';
import Fire from '../components/Calculators/Fire.vue';
import LoanPlanner from '../components/Calculators/LoanPlanner.vue';
import Mortgage from '../components/Calculators/Mortgage.vue';
import Paycheck from '../components/Calculators/Paycheck.vue';
import Retirement from '../components/Calculators/Retirement.vue';
import SavingsGoal from '../components/Calculators/SavingsGoal.vue';
import SubscriptionAudit from '../components/Calculators/SubscriptionAudit.vue';

const routes = [
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/UserAccount',
    name: 'UserAccount',
    component: UserAccount,
  },
  {
    path: '/Support',
    name: 'Support',
    component: Support,
  },
  {
    path: '/Transactions',
    name: 'Transactions',
    component: Transactions,
  },
  {
    path: '/EditTransaction/:userTransactionID',
    name: 'EditTransaction',
    component: EditTransaction,
    props: true,
  },
  {
    path: '/Categories',
    name: 'Categories',
    component: Categories,
  },
  {
    path: '/AddCategory',
    name: 'AddCategory',
    component: AddCategory,
  },
  {
    path: '/EditCategory',
    name: 'EditCategory',
    component: EditCategory,
  },
  {
    path: '/AddTransaction',
    name: 'AddTransaction',
    component: AddTransaction,
  },
  {
    path: '/Budget',
    name: 'Budget',
    component: Budget,
  },
  {
    path: '/NetWorth',
    name: 'NetWorth',
    component: NetWorth,
  },
  {
    path: '/CategoryTransactions',
    name: 'CategoryTransactions',
    component: CategoryTransactions,
  },
  {
    path: '/AddAccount',
    name: 'AddAccount',
    component: AddAccount,
  },
  {
    path: '/EditAccount/:previousPage',
    name: 'EditAccount',
    component: EditAccount,
    props: true,
  },
  {
    path: '/',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/UserProfile',
    name: 'UserProfile',
    component: UserProfile,
  },
  {
    path: '/ConnectedAccounts',
    name: 'ConnectedAccounts',
    component: ConnectedAccounts,
  },
  {
    path: '/EditCategoryBudget',
    name: 'EditCategoryBudget',
    component: EditCategoryBudget,
  },
  {
    path: '/AnnualBudgetDetails',
    name: 'AnnualBudgetDetails',
    component: AnnualBudgetDetails,
  },
  {
    path: '/ConnnectAccounts',
    name: 'ConnnectAccounts',
    component: ConnnectAccounts,
  },
  {
    path: '/UserCategoryData',
    name: 'UserCategoryData',
    component: UserCategoryData,
  },
  {
    path: '/UserData',
    name: 'UserData',
    component: UserData,
  },
  {
    path: '/UserCategoryData',
    name: 'UserCategoryData',
    component: UserCategoryData,
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: Settings,
  },
  {
    path: '/StripePayments',
    name: 'StripePayments',
    component: StripePayments,
  },
  {
    path: '/AccountType',
    name: 'AccountType',
    component: TypeOfAccountCreation,
  },
  {
    path: '/JuniorUserData',
    name: 'JuniorUserData',
    component: JuniorUserData,
  },
  {
    path: '/JuniorCategoryData',
    name: 'JuniorCategoryData',
    component: JuniorCategoryData,
  },
  {
    path: '/ConnectJuniorAccounts',
    name: 'ConnectJuniorAccounts',
    component: ConnectJuniorAccounts,
  },
  {
    path: '/Legal',
    name: 'Legal',
    component: Legal,
  },
  {
    path: '/DataDeletion',
    name: 'DataDeletion',
    component: DataDeletion,
  },
  {
    path: '/EndUserLicense',
    name: 'EndUserLicense',
    component: EndUserLicense,
  },
  {
    path: '/PlaidEnduser',
    name: 'PlaidEndUser',
    component: PlaidEndUser,
  },
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },
  {
    path: '/TermsOfUse',
    name: 'TermsOfUse',
    component: TermsOfUse,
  },
  {
    path: '/Calculators',
    name: 'Calculators',
    component: Calculators,
  },
  {
    path: '/Affordability',
    name: 'Affordability',
    component: Affordability,
  },
  {
    path: '/CompoundInterest',
    name: 'CompoundInterest',
    component: CompoundInterest,
  },
  {
    path: '/DebtPayoff',
    name: 'DebtPayoff',
    component: DebtPayoff,
  },
  {
    path: '/Fire',
    name: 'Fire',
    component: Fire,
  },
  {
    path: '/LoanPlanner',
    name: 'LoanPlanner',
    component: LoanPlanner,
  },
  {
    path: '/Mortgage',
    name: 'Mortgage',
    component: Mortgage,
  },
  {
    path: '/Paycheck',
    name: 'Paycheck',
    component: Paycheck,
  },
  {
    path: '/Retirement',
    name: 'Retirement',
    component: Retirement,
  },
  {
    path: '/SavingsGoal',
    name: 'SavingsGoal',
    component: SavingsGoal,
  },
  {
    path: '/SubscriptionAudit',
    name: 'SubscriptionAudit',
    component: SubscriptionAudit,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from) => {
  window.scrollTo(0, 0);

  const { isAuthenticated, isLoading } = useAuth0();

  while (isLoading.value) {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }

  if (to.meta.requiresAuth && !isAuthenticated.value) {
    return { name: 'SignIn' };
  }
});

// router.beforeEach(async (to, next) => {
//   window.scrollTo(0, 0);

//   const { isAuthenticated, isLoading } = useAuth0();

//   while (isLoading.value) {
//     await new Promise((resolve) => setTimeout(resolve, 50));
//   }

//   if (to.meta.requiresAuth && !isAuthenticated.value) {
//     next({ name: 'SignIn' });
//   }
// });

export default router;
